module.exports = __webpack_public_path__ + "static/media/grey-background.f3f1f38a.png";